import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer" >
            <span>R2S Version v2.0.1 (Lending Solutions Inc us-west-2) </span>
        </footer>
    )
}

export default Footer